var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0828 3.35387C32.7533 1.27343 37.2467 1.27343 40.9172 3.35387L50.225 8.62953L59.4478 14.0525C63.0847 16.191 65.3314 20.0824 65.365 24.3014L65.45 35L65.365 45.6986C65.3314 49.9176 63.0847 53.809 59.4478 55.9475L50.225 61.3705L40.9172 66.6461C37.2467 68.7266 32.7533 68.7266 29.0828 66.6461L19.775 61.3705L10.5522 55.9475C6.91528 53.809 4.66858 49.9176 4.63505 45.6986L4.55 35L4.63505 24.3014C4.66858 20.0824 6.91529 16.191 10.5522 14.0525L19.775 8.62953L29.0828 3.35387Z",
    fill: "#17233B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32.95V29C44 28.4477 43.5523 28 43 28H40M44 32.95H26M44 32.95V44C44 44.5523 43.5523 45 43 45H27C26.4477 45 26 44.5523 26 44V32.95M26 32.95V29C26 28.4477 26.4477 28 27 28H30M30 28V25M30 28H40M40 28V25",
    stroke: "#EDFF6B",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.7a91a2ac8f54b3437bb4245221a21c70.svg";
export { ForwardRef as ReactComponent };